import Vue from 'vue';
import App from './App.vue';
// import './registerServiceWorker'
// import './init'
import router from './router';
import store from './store';
import axiosInstance from '@/common/axios';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
// import '@/assets/styles/common/index.scss';
import '@/common/installVant';

import '@/common/infoCollect';

// 引入kdesign部分组件
// import '@/common/kdesign';

// 引入kdesign
import '@kdocs/kdesign-theme/default.css'; // KDesign 需要和主题搭配使用
import KDesignVue from '@kdocs/kdesign-vue';
import '@kdocs/kdesign-vue/lib/theme-chalk/index.css';
Vue.use(KDesignVue);

Vue.config.productionTip = false;
Vue.prototype.$http = axiosInstance;
Vue.use(Antd);

Vue.prototype.$eventBus = new Vue();

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

/* global __ENABLE_DEBUG__ */
// 编译期常量：生产包（packEnv=prod）整段 DCE，不打包 Debug 组件与 document 监听
if (__ENABLE_DEBUG__) {
  // eslint-disable-next-line global-require
  require('@/components/debug').initializeDebug();
}
